import { ResultFile } from '@alilc/lowcode-types';
import { createResultFile } from '../../../../../../../../../utils/resultHelper';

export default function getFile(): [string[], ResultFile] {
    const file = createResultFile(
        'index',
        'jsx',
        `
import {Layout, Menu, Breadcrumb, Row, Col,Result} from 'antd';
import "./index.less";
import {
    UserOutlined, MenuUnfoldOutlined, MenuFoldOutlined,SmileOutlined
} from '@ant-design/icons';
import {Switch} from "react-router-dom";
import {createElement,  useState} from "react";
import {menuData} from '@src/menuData'
import {getMenu,  fcGetMenuPath} from '@src/menu/menu'
import {RouteWithSubRoutes} from "@src/routes";

const {SubMenu} = Menu;
const {Header, Content, Sider} = Layout;

export default function BasicLayout(props) {

    let [state, setState] = useState({collapsed: false})
    let [breadcrumbMap, setBreadcrumbMap] = useState([])


    let toggle = () => {
        setState({
            collapsed: !state.collapsed,
        });
    };

    const handleMenuSelect = ({keyPath}) => {
        console.log(keyPath)
        const menuPath =  fcGetMenuPath(keyPath,menuData)
        setBreadcrumbMap(menuPath)
    }

    return <Layout theme="light" className="layout-console">

        <Sider width={200} trigger={null} className="site-layout-background" onCollapse={() => {
            console.log("test")
        }} collapsed={state.collapsed}>
            <div className="logo">
                {!state.collapsed && <span>Lowcode</span>}
            </div>
            {getMenu(menuData, handleMenuSelect)}
        </Sider>
        <Layout style={{padding: '0 5px 5px 5px '}}>
            <Header className="header">
                <Row>
                    <Col span={18} style={{display: "flex", justifyContent: "left", alignItems: "center"}}>
                        {createElement(state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
                            className: 'trigger',
                            onClick: toggle,
                        })}

                        {breadcrumbMap && <Breadcrumb style={{margin: '16px 10px', display: "inline-block"}}>
                            <Breadcrumb.Item>首页</Breadcrumb.Item>
                            {breadcrumbMap.map(item => {
                                return <Breadcrumb.Item>{item.name}</Breadcrumb.Item>
                            })}

                        </Breadcrumb>
                        }
                    </Col>
                    <Col span={6}>
                        <Menu style={{justifyContent: "right"}} mode='horizontal'>
                            <SubMenu key={"logout_submenu"} style={{float: "right"}}
                                     title={<span><UserOutlined/>{"请登录"}</span>}>
                                <Menu.Item key="logout">
                                    <a onClick="#">注销</a>
                                </Menu.Item>
                            </SubMenu>
                        </Menu>
                    </Col>
                </Row>

            </Header>

            <Content
                style={{
                    margin: 0,
                    minHeight: 280,
                }}
            >
                <Switch>
                    {props.routes.map((route, i) => (
                        <RouteWithSubRoutes key={i} {...route} />
                    ))}
                </Switch>
                <Row>
                    <Col span={8}></Col>
                    <Col span={8}><Result
                        icon={<SmileOutlined />}
                        title="欢迎使用低代码平台!"

                    /></Col>
                    <Col span={8}></Col>
                </Row>
            </Content>
        </Layout>
        {/*</Layout>*/}
    </Layout>;
}
    `,
    );

    return [['src', 'layouts', 'BasicLayout'], file];
}
